/*Function to convert a string to html
props:
	html: (string) the string to convert
*/
export function decodeHtml(html) { 
	let txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}